import { Box, Button, Switch, Text, Toast } from '@bonanza-social/moonlight';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import React, { useCallback, useEffect, useState } from 'react';
import { memo } from 'react';
import {
  getMarketingPreferences,
  selectMarketingPreferences,
  selectMarketingPreferencesDataState,
  updateMarketingPreferences,
} from '../../state';
import { useTranslation } from 'react-i18next';
import NotificationSkeleton from './NotificationsSkeleton';

function Notifications() {
  const dispatch = useDispatch();
  const { t } = useTranslation('account');

  const marketingPreferencesDataState = useSelector(
    selectMarketingPreferencesDataState,
  );
  const marketingPreferences = useSelector(selectMarketingPreferences);
  const [valueSMS, setValueSMS] = useState(false);
  const [valueEmail, setValueEmail] = useState(false);
  const [valueInbox, setValueInbox] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (marketingPreferences) {
      setValueSMS(marketingPreferences.allowSMSMarketingTool);
      setValueEmail(marketingPreferences.allowEmailMarketingTool);
      setValueInbox(marketingPreferences.allowInboxMarketingTool ?? false);
      setIsLoading(false);
    } else {
      dispatch(getMarketingPreferences());
    }
  }, [dispatch, marketingPreferences]);

  const handleSubmit = useCallback(async () => {
    const result = await dispatch(
      updateMarketingPreferences({
        allowSMSMarketingTool: valueSMS,
        allowEmailMarketingTool: valueEmail,
        allowInboxMarketingTool: valueInbox,
      }),
    );

    if (updateMarketingPreferences.fulfilled.match(result)) {
      Toast.show({
        type: 'success',
        title: t('notificationTitle'),
        text: t('notificationDescription'),
      });
    }

    if (updateMarketingPreferences.rejected.match(result)) {
      Toast.show({
        type: 'error',
        title: t('notificationErrorTitle'),
        text: t('notificationErrorDescription'),
      });
    }
  }, [dispatch, valueSMS, valueEmail, valueInbox, t]);

  if (isLoading) {
    return <NotificationSkeleton />;
  }

  return (
    <Box gap="space-400" width="100%">
      <Text
        variant="body-m-semi"
        locNS="account"
        locKey="notificationsDescription"
        color="darkSurfacePrimary"
      />
      <Box gap="space-300">
        <Box flexDirection="row" justifyContent="space-between">
          <Text
            variant="body-m-semi"
            locNS="account"
            locKey="sms"
            color="darkSurfacePrimary"
          />
          <Switch value={valueSMS} onValue={setValueSMS} />
        </Box>
        <Box flexDirection="row" justifyContent="space-between">
          <Text
            variant="body-m-semi"
            locNS="account"
            locKey="email"
            color="darkSurfacePrimary"
          />
          <Switch value={valueEmail} onValue={setValueEmail} />
        </Box>
        <Box flexDirection="row" justifyContent="space-between">
          <Text
            variant="body-m-semi"
            locNS="account"
            locKey="promotions"
            color="darkSurfacePrimary"
          />
          <Switch value={valueInbox} onValue={setValueInbox} />
        </Box>
      </Box>

      <Button
        locNS="common"
        locKey="save"
        variant="secondary"
        onPress={handleSubmit}
        loading={marketingPreferencesDataState === 'pending'}
      />
    </Box>
  );
}

export default memo(Notifications);
